/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import axios, { AxiosError } from 'axios'
import { redirect } from 'react-router-dom'
import { toast } from 'react-toastify'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  Button,
  Box,
  CircularProgress,
  InputAdornment,
  FormControlLabel,
  Checkbox
} from '@material-ui/core'
import { Cancel, NoteAdd, Save, ArrowDropDown, ArrowDropUp } from '@material-ui/icons'
import { ServerError } from '../../../schemas/Error'
import ThirdsContext from '../../../contexts/Third'
import { ThirdsContextType } from '../../../schemas/Third'
import Utils from '../../../utils'
import ItemTable from '../Common/ItemTable'
import PageContainer from '../Common/PageContainer'
import FormActions from '../Common/FormActions'
import SelectField from '../Common/SelectField'
import ThirdService from '../../../services/Third'
import SupportDocumentMapper from '../../../mappers/SupportDocument/supportDocument.mapper'
import ItemService from '../../../services/Item'
import { urls } from '../../../urls'
import { SupportDocumentFormSchema } from '../../../schemas/SupportDocument'
import SupportDocumentService from '../../../services/SupportDocument'
import moment from 'moment'
import { NumericFormat } from 'react-number-format'
// import permissions from '../../../permissions.json'

const WAY_TO_PAY_CONTADO = '1'
const WAY_TO_PAY_CREDITO = '2'

const getToday = () => moment().format('YYYY-MM-DD')
const getTomorrow = () => moment().add(1, 'day').format('YYYY-MM-DD')

// -------------- Styles ---------------
const useStyles = makeStyles((theme: Theme) => ({
  loadingContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    bottom: '0',
    right: '0',
    background: '#BFBFBFBF',
    opacity: 0.6,
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '50vh'
  },
  sectionDivider: {
    marginTop: theme.spacing(1),
  },
  alignRight: {
    textAlign: 'right',
  },
  addButton: {
    width: '100%',
    minHeight: 48,
    color: '#ffff',
  }
}))

// - in this part all the component texts are housed
const texts = {
  header: {
    description: 'Documento soporte'
  },
  body: {
    field: {
      date: {
        name: 'date',
        helperText: 'Fecha de compra',
        placeholder: 'Fecha'
      },
      orderReference: {
        name: 'orderReference',
        helperText: 'Escriba la referencia de orden',
        placeholder: 'Código de orden'
      },
      third: {
        name: 'third',
        helperText: 'Escoja el tercero',
        placeholder: 'Tercero'
      },
      postalZoneCode: {
        name: 'postalZoneCode',
        helperText: 'Número postal',
        placeholder: 'Número postal'
      },
      wayToPay: {
        name: 'wayToPay',
        helperText: 'Escoja una forma de pago',
        options: [
          { description: 'Contado', code: '1' },
          { description: 'Crédito', code: '2' },
        ]
      },
      paymentMethod: {
        name: 'paymentMethod',
        helperText: 'Escoja un método de pago',
        options: [
          { description: 'Cheque', code: '20' },
          { description: 'Consignación bancaria', code: '42' },
          { description: 'Efectivo', code: '10' },
          { description: 'Instrumento no definido', code: '1' },
          { description: 'Pago y depósito pre acordado (PPD)', code: '34' },
          { description: 'Tarjeta Crédito', code: '48' },
          { description: 'Tarjeta Débito', code: '49' },
        ]
      },
      paymentDueDate: {
        name: 'paymentDueDate',
        helperText: {
          contado: 'Coincide con la fecha del documento',
          credito: 'Debe ser posterior a la fecha actual',
          default: 'Fecha de pago'
        },
        placeholder: 'AAAA/MM/DD'
      },
      note: {
        name: 'note',
        helperText: 'Nota para la compra',
        placeholder: 'Nota para la compra'
      },
      item: {
        name: 'currentItem',
        helperText: 'Escoja el producto a comprar',
        options: [
          {
            unitMeasure: { code: 12, description: 'Unidad' },
            description: 'Producto de prueba',
            code: '1',
            price: 2500
          }
        ]
      },
      itemType: {
        name: 'currentItemType',
        helperText: 'Tipo de producto',
        options: [
          { description: 'UNSPSC', code: '1' },
          { description: 'GTIN', code: '2' },
          { description: 'Partida Arancelarias', code: '3' },
          { description: 'Estándar de adopción del contribuyente', code: '4' }
        ]
      },
      price: {
        name: 'currentPrice',
        helperText: 'Precio',
        placeholder: 'Precio'
      },
      quantity: {
        name: 'currentQuantity',
        helperText: 'Cantidad',
        placeholder: 'Cantidad'
      },
      detailedDescription: {
        name: 'currentDetailedDescription',
        helperText: 'Descripción detallada (opcional)',
        placeholder: 'Descripción detallada del producto'
      },
      applyHoldingsTaxes: {
        name: 'applyHoldingsTaxes',
        helperText: 'Aplicar retenciones'
      },
      tax: {
        name: 'selectedHoldingTax',
        helperText: 'Escoja el impuesto',
        options: [
          { code: '5', description: 'ReteIVA' },
          { code: '6', description: 'ReteRenta' },
          { code: '7', description: 'ReteICA' }
        ]
      },
      percent: {
        name: 'currentPercentHoldingTax',
        helperText: 'Porcentaje',
        placeholder: '%',
        options: [
          { code: 0.1, description: '0.1%' },
          { code: 0.5, description: '0.5%' },
          { code: 1, description: '1%' },
          { code: 2, description: '2%' },
          { code: 2.5, description: '2.5%' },
          { code: 3, description: '3%' },
          { code: 3.5, description: '3.5%' },
          { code: 4, description: '4%' },
          { code: 6, description: '6%' },
          { code: 7, description: '7%' },
          { code: 10, description: '10%' },
          { code: 11, description: '11%' },
          { code: 20, description: '20%' },
        ]
      },
      total: {
        name: 'total',
        helperText: 'Total sin impuestos',
        placeholder: 'Total sin impuestos'
      },
      totalHoldingTaxes: {
        name: 'totalHoldingTaxes',
        helperText: 'Total de retenciones',
        placeholder: 'Total de retenciones'
      },
      totalToPay: {
        name: 'totalToPay',
        helperText: 'Total final',
        placeholder: 'Total'
      }
    },
    subtitles: {
      payment: 'Información acerca del pago',
      itemsTable: 'Tabla de productos a comprar',
      total: 'Información acerca de los totales del documento soporte'
    },
    buttons: {
      addProduct: {
        title: 'Agregar'
      }
    },

  }
}

// ------------ Init state -----------
interface State {
  form: SupportDocumentFormSchema
  applyHoldingsTaxes: boolean
  items: any[]
  selectedItems: any[]
  thirds: any[]
  preview?: string
  loading: boolean
  disabledForm: boolean
  status: boolean
  thirdSelected?: string
  suggestionsThirds: any[]
  showScheduleModal: boolean
  scheduledBill: boolean
}

const getPaymentDueDateHelperText = (wayToPayCode: string) => {
  if (wayToPayCode === WAY_TO_PAY_CONTADO) {
    return texts.body.field.paymentDueDate.helperText.contado
  }
  if (wayToPayCode === WAY_TO_PAY_CREDITO) {
    return texts.body.field.paymentDueDate.helperText.credito
  }
  return texts.body.field.paymentDueDate.helperText.default
}

const getInitState = (): State => ({
  form: {
    date: getToday(),
    orderReference: '',
    third: undefined,
    postalZoneCode: '',
    wayToPay: { code: '', description: '' },
    paymentMethod: { code: '', description: '' },
    paymentDueDate: '',
    note: '',
    currentItem: undefined,
    currentItemType: {
      code: '',
      description: ''
    },
    currentPrice: 0,
    currentQuantity: 0,
    total: 0,
    totalHoldingTaxes: 0,
    totalToPay: 0,
    selectedHoldingTax: { code: '', description: '' },
    currentPercentHoldingTax: 0,
    currentDetailedDescription: ''
  },
  items: [],
  applyHoldingsTaxes: false,
  selectedItems: [],
  thirds: [],
  preview: undefined,
  loading: false,
  disabledForm: false,
  status: false,
  thirdSelected: '',
  suggestionsThirds: [],
  showScheduleModal: false,
  scheduledBill: false
})

export default function SupportDocumentForm() {
  const classes = useStyles()

  const [state, setState] = useState(getInitState)

  const { setThirdsContext } = React.useContext(
    ThirdsContext
  ) as ThirdsContextType

  React.useEffect(() => {

    async function loadData() {
      try {
        // Load service
        const thirdService = new ThirdService()
        const itemService = new ItemService()
        const thirds = await thirdService.getThirds()
        const items = await itemService.getItems()

        setState({
          ...state,
          thirds: thirds.thirds,
          suggestionsThirds: thirds.thirds,
          items: items.items,
          selectedItems: []
        })
        setThirdsContext(thirds.thirds) // save in context
        localStorage.setItem('thirds', JSON.stringify(thirds.thirds))
      } catch (error) {

        setState({
          ...state,
          loading: false
        })

        if (axios.isAxiosError(error)) {
          const serverError = error as AxiosError<ServerError>
          if (serverError && serverError.response) {
            return toast.error(serverError.response.data.message || error.toString())
          }
        }
      }
    }

    loadData()
  }, [])

  const handleChangeSelectValue = (name: string, value: string | number) => {
    setState({
      ...state,
      form: {
        ...state.form,
        [name]: value
      }
    })
  }

  // HandleChangeSelect is the handler to update the state
  // of the state, while the user change the options 
  // on an input select.
  const handleChangeSelect = (
      name: string,
      item: {
        code: string,
        description: string,
        price?: number,
        itemType?: any,
        name?: string,
        lastname?: string,
        businessName?: string
      }) => {
    if (item.price && item.itemType) {
      setState({
        ...state,
        form: {
          ...state.form,
          [name]: item,
          currentPrice: item.price,
          currentItemType: {
            code: item.itemType.code,
            description: item.itemType.description
          }
        }
      })
    } else if (name === texts.body.field.third.name) {
      setState({
        ...state,
        form: {
          ...state.form,
          [name]: item
        },
        thirdSelected: item.name !== undefined ? `${item.name} ${item.lastname}` : `${item.businessName}`,
        status: false
      })
    } else if (name === texts.body.field.wayToPay.name) {
      const today = getToday()
      setState({
        ...state,
        form: {
          ...state.form,
          [name]: item,
          date: today,
          paymentDueDate: item.code === WAY_TO_PAY_CONTADO ? today : ''
        }
      })
    } else {
      setState({
        ...state,
        form: {
          ...state.form,
          [name]: item
        }
      })
    }
  }

  // HandleChange is the handler to update the state
  // of the state, while the user writes on an input.
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | {
    name: string
    value: unknown
  }>) => {
    const { name, value } = e.target
    setState({
      ...state,
      form: {
        ...state.form,
        [name]: value
      }
    })
  }

  const handleSuggestions = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    const suggestionsThirds = state.thirds.filter(third => {
      if (third.name?.toLowerCase().includes(value.toLowerCase())) {
        return third
      } else if (third.lastname?.toLowerCase().includes(value.toLowerCase())) {
        return third
      } else if (third.businessName?.toLowerCase().includes(value.toLowerCase())) {
        return third
      }
      return false
    })

    setState({
      ...state,
      thirdSelected: value,
      suggestionsThirds,
      status: value.length > 0 ? true : false
    })
  }

  // HandleSubmit is the handler to verify and send
  // the state to redux (redux send the info to backend)
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    setState({
      ...state,
      loading: true
    })

    try {
      // Validations
      if (!state.form.third) throw new Error('Debe seleccionar un tercero del listado')

      const today = getToday()
      let formToSubmit = { ...state.form, date: today }

      if (formToSubmit.wayToPay.code === WAY_TO_PAY_CONTADO) {
        formToSubmit = { ...formToSubmit, paymentDueDate: today }
      } else if (formToSubmit.wayToPay.code === WAY_TO_PAY_CREDITO) {
        if (!formToSubmit.paymentDueDate || formToSubmit.paymentDueDate <= today) {
          throw new Error('La fecha de pago debe ser posterior a la fecha actual')
        }
      }

      const res = SupportDocumentMapper.formToSchema(formToSubmit, state.selectedItems)
      const supportDocumentService = new SupportDocumentService()
      const response = await supportDocumentService.save(res)
 
      setState({
        ...getInitState(),
        items: state.items,
        selectedItems: [],
        thirds: state.thirds,
        preview: response.data.cude,
        loading: false
      })

      redirect(urls.app.main.supportDocument.form)
      return toast.success(`Documento soporte creado con éxito`)
    } catch (error) {

      setState({
        ...state,
        loading: false
      })
      
      if (axios.isAxiosError(error)) {
        const serverError = error as AxiosError<ServerError>
        if (serverError && serverError.response) {
          return toast.error(serverError.response.data.message || error.toString())
        }
      } else if (error instanceof Error) {
        return toast.error(error.message)
      }
    }
  }

  // HandleTable is the handler to add and remove items
  // from the concept table, it also adds or subtracts 
  // the value of the total receipt.
  const handleTable = (func: string, selectedItem?: any) => {
    if (func === 'ADD') {
      const item = Utils.buildItemForSupportDocument(state.form, state.applyHoldingsTaxes)
      const total = Utils.roundToMaxDecimals(state.form.total + item.total)
      const totalHoldingTaxes = Utils.roundToMaxDecimals(state.form.totalHoldingTaxes + item.taxes[0].taxAmount)
      const totalToPay = Utils.roundToMaxDecimals(total + totalHoldingTaxes)
      const items = state.selectedItems
      items.push(item)
      setState({
        ...state,
        form: {
          ...state.form,
          total: total,
          totalHoldingTaxes: totalHoldingTaxes,
          totalToPay: totalToPay,
          currentItemType: {
            code: '',
            description: ''
          },
          currentPrice: 0,
          currentQuantity: 0,
          selectedHoldingTax: { code: '', description: '' },
          currentPercentHoldingTax: 0,
          currentDetailedDescription: ''
        },
        selectedItems: items
      })
    }

    if (func === 'REMOVE') {
      const total = Utils.roundToMaxDecimals(state.form.total - selectedItem.total)
      const totalHoldingTaxes = Utils.roundToMaxDecimals(state.form.totalHoldingTaxes - selectedItem.taxes[0].taxAmount)
      const totalToPay = Utils.roundToMaxDecimals(total + totalHoldingTaxes)
      const items = state.selectedItems.filter(item => item.code !== selectedItem.code)
      setState({
        ...state,
        form: {
          ...state.form,
          total: total,
          totalHoldingTaxes: totalHoldingTaxes,
          totalToPay: totalToPay,
        },
        selectedItems: items
      })
    }
  }

  const onApplyHoldingsTaxes = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { checked } = event.target
      setState({
        ...state,
        applyHoldingsTaxes: checked
      })
    }

  const cancel = () => {
    setState({
      ...getInitState(),
      items: state.items,
      selectedItems: [],
      thirds: state.thirds,
      preview: undefined,
      loading: false
    })
  }

  const onPreviewBill = async () => {
    if (!state.disabledForm) {
      setState({
        ...state,
        preview: undefined
      })
    }

    // Si tenemos un CUDE, obtener el HTML y generar PDF
    if (state.preview) {
      try {
        const supportDocumentService = new SupportDocumentService()
        const htmlContent = await supportDocumentService.getSupportDocumentHTML(state.preview)
        
        // Generar el PDF con el HTML obtenido
        const documentNumber = state.preview
        Utils.generateSupportDocumentPDF(htmlContent, documentNumber)
        
        // Mostrar mensaje de éxito
        toast.success('PDF de documento soporte generado correctamente')
      } catch (error) {
        console.error('Error generando PDF de documento soporte:', error)
        toast.error(`Error generando PDF de documento soporte: ${error}`)
      }
    } else {
      toast.error('No hay documento soporte disponible')
    }
  }

  return (
    <PageContainer title={texts.header.description}>

      {/* ----- Body ------*/}
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>

          {/* ----- Form: order reference ------*/}
          <Grid item xs={12}>
            <TextField
              required={true}
              name={texts.body.field.orderReference.name}
              label={texts.body.field.orderReference.placeholder}
              value={state.form.orderReference}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.orderReference.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          {/* ----- Form: third ------*/}
          <Grid item md={8} sm={8} xs={12}>
            <TextField 
              name="thirdSelected"
              label={texts.body.field.third.placeholder}
              value={state.thirdSelected}
              autoComplete='off'
              variant="outlined"
              fullWidth
              disabled={state.disabledForm}
              onChange={handleSuggestions}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton aria-label="Mostrar terceros" onClick={() => setState({...state, status: !state.status})}>
                    {
                      state.status ? 
                      (
                        <ArrowDropUp fontSize={"small"} color="secondary" />
                      ) :
                      (
                        <ArrowDropDown fontSize={"small"} color="primary" />
                      )
                    }
                  </IconButton>
                </InputAdornment>,
              }}
            />
            {
              state.status === true && (
                <Box sx={{
                  width: '100%',
                  maxHeight: 100,
                  display: 'relative',
                  zIndex: 1,
                  bgcolor: '#E1E1E1',
                  overflow: 'auto'
                }}>
                  {
                    state.suggestionsThirds.map((third) =>
                      <MenuItem
                        key={third.document}
                        onClick={() => handleChangeSelect(texts.body.field.third.name, third)}
                      >
                        {third.name !== undefined ? `${third.name} ${third.lastname}` : `${third.businessName}`}
                      </MenuItem>
                    )
                  }
                </Box>
              )
            }
            <FormHelperText style={{ margin: '3px 14px 0' }}>{texts.body.field.third.helperText}</FormHelperText>
          </Grid>

          <Grid item md={4} sm={4} xs={12}>
            <TextField
              required={true}
              name={texts.body.field.postalZoneCode.name}
              label={texts.body.field.postalZoneCode.placeholder}
              value={state.form.postalZoneCode}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.postalZoneCode.helperText}
              inputProps={{ inputMode: 'numeric' }}
              disabled={state.disabledForm}
            />
          </Grid>

          {/* ----- Form: payment ------*/}

          <Grid item md={4} sm={6} xs={12}>
            <SelectField
              name={texts.body.field.wayToPay.name}
              label="Forma de pago"
              value={state.form.wayToPay.code}
              helperText={texts.body.field.wayToPay.helperText}
              disabled={state.disabledForm}
            >
              {
                texts.body.field.wayToPay.options.map((item) =>
                  <MenuItem
                    key={item.description}
                    value={item.code}
                    onClick={() => handleChangeSelect(texts.body.field.wayToPay.name, item)}
                  >
                    {item.description}
                  </MenuItem>
                )
              }
            </SelectField>
          </Grid>

          {/* ----- Form: payment method ------*/}
          <Grid item md={4} sm={6} xs={12}>
            <SelectField
              name={texts.body.field.paymentMethod.name}
              label="Método de pago"
              value={state.form.paymentMethod.code}
              helperText={texts.body.field.paymentMethod.helperText}
              disabled={state.disabledForm}
            >
              {
                texts.body.field.paymentMethod.options.map((item) =>
                  <MenuItem
                    key={item.description}
                    value={item.code}
                    onClick={() => handleChangeSelect(texts.body.field.paymentMethod.name, item)}
                  >
                    {item.description}
                  </MenuItem>
                )
              }
            </SelectField>
          </Grid>

          {/* ----- Form: payment due date ------*/}
          <Grid item md={4} sm={12} xs={12}>
            <TextField
              required={true}
              name={texts.body.field.paymentDueDate.name}
              label="Fecha de pago"
              value={state.form.paymentDueDate}
              variant='outlined'
              type='date'
              fullWidth
              onChange={handleChange}
              helperText={getPaymentDueDateHelperText(state.form.wayToPay.code)}
              InputLabelProps={{ shrink: true }}
              disabled={state.disabledForm || state.form.wayToPay.code !== WAY_TO_PAY_CREDITO}
              inputProps={
                state.form.wayToPay.code === WAY_TO_PAY_CREDITO
                  ? { min: getTomorrow() }
                  : undefined
              }
            />
          </Grid>

          {/* ----- Form: note ------*/}

          <Grid item xs={12}>
            <TextField
              required={true}
              name={texts.body.field.note.name}
              label={texts.body.field.note.placeholder}
              value={state.form.note}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.note.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          {/* ----- Form: item ------*/}

          <Grid item xs={12}>
            <Typography
              variant='h6'
            >
              {texts.body.subtitles.itemsTable}
            </Typography>
            <Divider className={classes.sectionDivider} />
          </Grid>

          <Grid item md={8} sm={12} xs={12}>
            <SelectField
              name={texts.body.field.item.name}
              label="Producto"
              value={state.form.currentItem?.code ?? ''}
              helperText={texts.body.field.item.helperText}
              disabled={state.disabledForm}
            >
              {
                state.items.map((item) =>
                  <MenuItem
                    key={item.description}
                    value={item.code}
                    onClick={() => handleChangeSelect(texts.body.field.item.name, item)}
                  >
                    {item.description}
                  </MenuItem>
                )
              }
            </SelectField>
          </Grid>

          {/* ----- Form: item type ------*/}
          <Grid item md={4} sm={12} xs={12}>
            <SelectField
              name={texts.body.field.itemType.name}
              label="Tipo de producto"
              value={state.form.currentItemType.code}
              helperText={texts.body.field.itemType.helperText}
              disabled={state.disabledForm}
            >
              {
                texts.body.field.itemType.options.map((item) =>
                  <MenuItem
                    key={item.description}
                    value={item.code}
                    onClick={() => handleChangeSelect(texts.body.field.itemType.name, item)}
                  >
                    {item.description}
                  </MenuItem>
                )
              }
            </SelectField>
          </Grid>

          {/* ----- Form: price ------*/}
          <Grid item md={8} sm={6} xs={12}>
            <NumericFormat
              required={true}
              name={texts.body.field.price.name}
              label={texts.body.field.price.placeholder}
              value={state.form.currentPrice ?? ''}
              onValueChange={(values) =>
                setState({
                  ...state,
                  form: {
                    ...state.form,
                    currentPrice: Utils.roundToMaxDecimals(values.floatValue ?? 0)
                  }
                })
              }
              decimalScale={Utils.getMaxPriceDecimals()}
              thousandSeparator="."
              decimalSeparator=","
              prefix="COP "
              allowNegative={false}
              customInput={TextField}
              variant="outlined"
              fullWidth
              inputMode="decimal"
              helperText={texts.body.field.price.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          {/* ----- Form: quantity ------*/}
          <Grid item md={4} sm={6} xs={12}>
            <TextField
              required={true}
              name={texts.body.field.quantity.name}
              label={texts.body.field.quantity.placeholder}
              value={state.form.currentQuantity}
              variant='outlined'
              type='number'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.quantity.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              name={texts.body.field.detailedDescription.name}
              label={texts.body.field.detailedDescription.placeholder}
              value={state.form.currentDetailedDescription}
              variant='outlined'
              fullWidth
              multiline
              minRows={2}
              onChange={handleChange}
              helperText={texts.body.field.detailedDescription.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          <Grid item xs={12}>
            {/* ----- apply taxes check ------*/}
            <FormControlLabel
              control={<Checkbox checked={state.applyHoldingsTaxes} name={texts.body.field.applyHoldingsTaxes.name} value={state.applyHoldingsTaxes} onChange={(e) => onApplyHoldingsTaxes(e)} color="primary" />}
              label={texts.body.field.applyHoldingsTaxes.helperText}
              disabled={state.disabledForm}
            />
          </Grid>

          {
            state.applyHoldingsTaxes ?
              (
                <React.Fragment>
                  <Grid item md={6} sm={6} xs={12}>
                    <SelectField
                      name={texts.body.field.tax.name}
                      label="Retención"
                      value={state.form.selectedHoldingTax.code}
                      helperText={texts.body.field.tax.helperText}
                    >
                      {
                        texts.body.field.tax.options.map((item) =>
                          <MenuItem
                            key={item.description}
                            value={item.code}
                            onClick={() => handleChangeSelect(texts.body.field.tax.name, item)}
                          >
                            {item.description}
                          </MenuItem>
                        )
                      }
                    </SelectField>
                  </Grid>

                  {/* ----- Form: percent ------*/}
                  {state.form.selectedHoldingTax.code === texts.body.field.tax.options[1].code ? (
                    <Grid item md={3} sm={6} xs={12}>
                      <SelectField
                        name={texts.body.field.percent.name}
                        label="Porcentaje"
                        value={state.form.currentPercentHoldingTax}
                        helperText={texts.body.field.percent.helperText}
                      >
                        {
                          texts.body.field.percent.options.map((item) =>
                            <MenuItem
                              key={item.description}
                              value={item.code}
                              onClick={() => handleChangeSelectValue(texts.body.field.percent.name, item.code)}
                            >
                              {item.description}
                            </MenuItem>
                          )
                        }
                      </SelectField>
                    </Grid>

                  ) : (
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        required={true}
                        name={texts.body.field.percent.name}
                        label="Porcentaje"
                        value={state.form.currentPercentHoldingTax}
                        variant='outlined'
                        type='number'
                        fullWidth
                        onChange={handleChange}
                        helperText={texts.body.field.percent.helperText}
                        disabled={state.disabledForm}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              ) : ''
          }

          <Grid item md={3} sm={12} xs={12}>
            <Button
              variant="contained"
              type="button"
              color="primary"
              size="large"
              onClick={() => handleTable("ADD")}
              className={classes.addButton}
              startIcon={<Save />}
              disabled={state.disabledForm}
            >
              {texts.body.buttons.addProduct.title}
            </Button>
          </Grid>

          {/* ----- Form: item **concepts table rendering ------*/}
          <Grid item xs={12}>
            <ItemTable rows={state.selectedItems} handleTable={handleTable} disabledForm={state.disabledForm} />
          </Grid>

          {/* ----- Form: total ------*/}
          <Grid item md={4} sm={12} xs={12}>
            <TextField
              disabled={true}
              name={texts.body.field.total.name}
              label={texts.body.field.total.placeholder}
              value={Utils.formatNumber(state.form.total)}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.total.helperText}
            />
          </Grid>

          {/* ----- Form: total taxes ------*/}
          <Grid item md={4} sm={6} xs={12}>
            <TextField
              disabled={true}
              name={texts.body.field.totalHoldingTaxes.name}
              label={texts.body.field.totalHoldingTaxes.placeholder}
              value={Utils.formatNumber(state.form.totalHoldingTaxes)}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.totalHoldingTaxes.helperText}
            />
          </Grid>

          {/* ----- Form: total to pay ------*/}
          <Grid item md={4} sm={6} xs={12}>
            <TextField
              disabled={true}
              name={texts.body.field.totalToPay.name}
              label={texts.body.field.totalToPay.placeholder}
              value={Utils.formatNumber(state.form.totalToPay)}
              variant='outlined'
              fullWidth
              onChange={handleChange}
              helperText={texts.body.field.totalToPay.helperText}
            />
          </Grid>

          {
            state.preview !== undefined ?
              (
                <Grid item xs={12} className={classes.alignRight}>
                  <Button 
                    variant="text" 
                    color="primary"
                    onClick={onPreviewBill}
                    style={{ textDecoration: 'underline' }}
                  >
                    Descargar PDF del documento soporte
                  </Button>
                </Grid>
              ) : ''
          }
        </Grid>

        {
          !state.disabledForm ?
          (
            <FormActions>
              <Button type="button" variant="outlined" color="secondary" startIcon={<Cancel />} onClick={cancel}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary" startIcon={<NoteAdd />}>
                Emitir
              </Button>
            </FormActions>
          ) : ''
        }
      </form>
      {
        state.loading ?
          (
            <div className={classes.loadingContainer}>
              <Box>
                <CircularProgress />
              </Box>
            </div>
          ) : ''
      }
    </PageContainer>
  )
}
